// Reactive (Vue.observable-based) modal registry, replacing the DOM/data-attribute
// driven modal behavior in nativeUiBehaviors.js with genuine Vue state. Modal
// components stay decoupled from their trigger buttons (which are very often in a
// different .vue file / component tree) via a shared string id, same as the old
// data-bs-target="#fooId" convention did.
import Vue from 'vue';

const state = Vue.observable({
    openStack: [],   // ids, in the order they were opened; last = topmost
    options: {},     // id -> { backdrop: true|false|'static', keyboard: true|false }
});

export function registerModal(id, options = {}) {
    state.options[id] = { backdrop: true, keyboard: true, ...options };
}

export function openModal(id) {
    if (!state.openStack.includes(id)) state.openStack.push(id);
}

export function closeModal(id) {
    const i = state.openStack.indexOf(id);
    if (i !== -1) state.openStack.splice(i, 1);
}

export function isModalOpen(id) {
    return state.openStack.includes(id);
}

export function anyModalOpen() {
    return state.openStack.length > 0;
}

function topModalId() {
    return state.openStack[state.openStack.length - 1];
}

// A modal's own backdrop-click handler should call this instead of closeModal()
// directly, so a `data-bs-backdrop="static"`-equivalent modal correctly ignores
// backdrop clicks (matches the previous nativeUiBehaviors.js semantics).
export function closeModalUnlessStatic(id) {
    const opts = state.options[id] || {};
    if (opts.backdrop !== 'static' && opts.backdrop !== false) closeModal(id);
}

let installed = false;

// Escape closes only the topmost modal, and only if it doesn't have a static
// backdrop / keyboard:false, mirroring the previous nativeUiBehaviors.js behavior.
export function installModalKeyboardHandling() {
    if (installed) return;
    installed = true;
    document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const id = topModalId();
        if (!id) return;
        const opts = state.options[id] || {};
        if (opts.backdrop !== 'static' && opts.keyboard !== false) {
            closeModal(id);
        }
    });
}
